import routes from "@/routes/routes";
import React from "react";

interface RouteSidebar {
  show: boolean;
  icon?: React.ReactNode;
  name?: string;
}

interface RouteConfig {
  path: string;
  element?: React.ReactNode;
  pageName?: string;
  permissionName?: string;
  sidebar?: RouteSidebar;
  children?: Record<string, RouteConfig>;
}

export interface SidebarChild {
  id: string;
  path: string;
  icon?: React.ReactNode | undefined;
  pageName?: string | undefined;
  permissionName?: string | undefined;
}

export interface SidebarItem {
  id: string;
  path: string;
  icon?: React.ReactNode | undefined;
  pageName?: string | undefined;
  permissionName?: string | undefined;
  children?: SidebarChild[];
}

// Type guard for sidebar
const hasSidebar = (
  pageData: any
): pageData is {
  sidebar?: { show?: boolean; icon?: React.ReactNode; name?: string };
} => pageData && "sidebar" in pageData && typeof pageData.sidebar === "object";

// Type guard for children
const hasChildren = (
  pageData: any
): pageData is { children: Record<string, any> } =>
  pageData && typeof pageData.children === "object";
export const sideBarNavigation: SidebarItem[] = Object.values(
  routes.privateRoutes as Record<string, RouteConfig>
)
  .filter((page) => page.sidebar?.show || page.children)
  .map((pageData, index) => {
    const data: SidebarItem = {
      id: (index + 1).toString(),
      path: pageData.path,
      icon: pageData.sidebar?.icon,
      pageName: pageData.sidebar?.name || pageData.pageName,
      permissionName: pageData.permissionName,
    };

    if (pageData.children) {
      data.children = Object.values(pageData.children)
        .filter((child) => child.sidebar?.show)
        .map((child, childIndex) => ({
          id: `${index + 1}-${childIndex + 1}`, // unique ID
          path: child.path,
          icon: child.sidebar?.icon,
          pageName: child.sidebar?.name || child.pageName,
          permissionName: child.permissionName,
        }));
    }

    return data;
  });
